import { ClipLoader } from "react-spinners";

import styles from "./styles.module.scss";

const LoaderScreen = () => {
  return (
    <div className={styles.loader_container}>
      <ClipLoader size={50} color="#fb3973" />
    </div>
  );
};

export default LoaderScreen;
